import { createReducer } from 'redux-act';
import actions from "../actions/attendanceCorrectionActions";

const initialState = {
    applyAttendanceCorrectionPending: false,
    applyAttendanceCorrectionRes: null,
    applyAttendanceCorrectionError: null,

    getAttendanceCorrectionRequestDataPending: false,
    getAttendanceCorrectionRequestDataRes: null,
    getAttendanceCorrectionRequestDataError: null,

    approveRejectAttendanceCorrectionPending: false,
    approveRejectAttendanceCorrectionRes: null,
    approveRejectAttendanceCorrectionError: null,

    getAttendanceCorrectionApprovalPending: false,
    getAttendanceCorrectionApprovalRes: null,
    getAttendanceCorrectionApprovalError: null,

    updateAttendanceLogPending: false,
    updateAttendanceLogRes: null,
    updateAttendanceLogError: null,

    getAttendanceLogsPending: false,
    getAttendanceLogsRes: null,
    getAttendanceLogsError: null,

    attendanceCorrectionLogsPending: false,
    attendanceCorrectionLogsRes: null,
    attendanceCorrectionLogsError: null,

    correctionFormData: null,
}

/* Apply Attendance Correction Reducers */
const handleApplyAttendanceCorrectionRequest = state => {
    return {
        ...state,
        ...{
            applyAttendanceCorrectionPending: true,
            applyAttendanceCorrectionRes: null,
            applyAttendanceCorrectionError: null,
        },
    };
};
const handleApplyAttendanceCorrectionSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            applyAttendanceCorrectionPending: false,
            applyAttendanceCorrectionRes: payload,
            applyAttendanceCorrectionError: null,
        },
    };
};
const handleApplyAttendanceCorrectionError = (state, payload) => ({
    ...state,
    ...{
        applyAttendanceCorrectionPending: false,
        applyAttendanceCorrectionRes: null,
        applyAttendanceCorrectionError: payload,
    },
});

/* Get Attendance Correction Request Data Reducers */
const handleGetAttendanceCorrectionRequestDataRequest = state => {
    return {
        ...state,
        ...{
            getAttendanceCorrectionRequestDataPending: true,
            getAttendanceCorrectionRequestDataRes: null,
            getAttendanceCorrectionRequestDataError: null,
        },
    };
};
const handleGetAttendanceCorrectionRequestDataSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            getAttendanceCorrectionRequestDataPending: false,
            getAttendanceCorrectionRequestDataRes: payload,
            getAttendanceCorrectionRequestDataError: null,
        },
    };
};
const handleGetAttendanceCorrectionRequestDataError = (state, payload) => ({
    ...state,
    ...{
        getAttendanceCorrectionRequestDataPending: false,
        getAttendanceCorrectionRequestDataRes: null,
        getAttendanceCorrectionRequestDataError: payload,
    },
});


/* Approve Reject Attendance Correction Reducers */
const handleApproveRejectAttendanceCorrectionRequest = state => {
    return {
        ...state,
        ...{
            approveRejectAttendanceCorrectionPending: true,
            approveRejectAttendanceCorrectionRes: null,
            approveRejectAttendanceCorrectionError: null,
        },
    };
};
const handleApproveRejectAttendanceCorrectionSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            approveRejectAttendanceCorrectionPending: false,
            approveRejectAttendanceCorrectionRes: payload,
            approveRejectAttendanceCorrectionError: null,
        },
    };
};
const handleApproveRejectAttendanceCorrectionError = (state, payload) => ({
    ...state,
    ...{
        approveRejectAttendanceCorrectionPending: false,
        approveRejectAttendanceCorrectionRes: null,
        approveRejectAttendanceCorrectionError: payload,
    },
});

/* Get Attendance Correction Approval Reducers */
const handleGetAttendanceCorrectionApprovalRequest = state => {
    return {
        ...state,
        ...{
            getAttendanceCorrectionApprovalPending: true,
            getAttendanceCorrectionApprovalRes: null,
            getAttendanceCorrectionApprovalError: null,
        },
    };
};
const handleGetAttendanceCorrectionApprovalSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            getAttendanceCorrectionApprovalPending: false,
            getAttendanceCorrectionApprovalRes: payload,
            getAttendanceCorrectionApprovalError: null,
        },
    };
};
const handleGetAttendanceCorrectionApprovalError = (state, payload) => ({
    ...state,
    ...{
        getAttendanceCorrectionApprovalPending: false,
        getAttendanceCorrectionApprovalRes: null,
        getAttendanceCorrectionApprovalError: payload,
    },
});

/* Update Attendance Log Reducers */
const handleUpdateAttendanceLogRequest = state => {
    return {
        ...state,
        ...{
            updateAttendanceLogPending: true,
            updateAttendanceLogRes: null,
            updateAttendanceLogError: null,
        },
    };
};
const handleUpdateAttendanceLogSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            updateAttendanceLogPending: false,
            updateAttendanceLogRes: payload,
            updateAttendanceLogError: null,
        },
    };
};
const handleUpdateAttendanceLogError = (state, payload) => ({
    ...state,
    ...{
        updateAttendanceLogPending: false,
        updateAttendanceLogRes: null,
        updateAttendanceLogError: payload,
    },
});

/* Get Attendance Logs Reducers */
const handleGetAttendanceLogsRequest = state => {
    return {
        ...state,
        ...{
            getAttendanceLogsPending: true,
            getAttendanceLogsRes: null,
            getAttendanceLogsError: null,
        },
    };
};
const handleGetAttendanceLogsSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            getAttendanceLogsPending: false,
            getAttendanceLogsRes: payload,
            getAttendanceLogsError: null,
        },
    };
};
const handleGetAttendanceLogsError = (state, payload) => ({
    ...state,
    ...{
        getAttendanceLogsPending: false,
        getAttendanceLogsRes: null,
        getAttendanceLogsError: payload,
    },
});

/* Get Attendance Logs Reducers */
const handleAttendanceCorrectionLogsRequest = state => {
    return {
        ...state,
        ...{
            attendanceCorrectionLogsPending: true,
            attendanceCorrectionLogsRes: null,
            attendanceCorrectionLogsError: null,
        },
    };
};
const handleAttendanceCorrectionLogsSuccess = (state, payload) => {
    return {
        ...state,
        ...{
            attendanceCorrectionLogsPending: false,
            attendanceCorrectionLogsRes: payload,
            attendanceCorrectionLogsError: null,
        },
    };
};
const handleAttendanceCorrectionLogsError = (state, payload) => ({
    ...state,
    ...{
        attendanceCorrectionLogsPending: false,
        attendanceCorrectionLogsRes: null,
        attendanceCorrectionLogsError: payload,
    },
});

/* Employee Details Reducers */
const handleCorrectionFormData = (state1, payload) => ({
    ...state1,
    ...{
        correctionFormData: payload,
    }

});


/* Clear Attendance Correction Reducers */
const handleClearCorrectionReducers = (state, payload) => {
    switch (payload) {
        case 'HANDLE_CLEAR_APPROVE_REJECT_ATTENDANCE_CORRECTION':
            return {
                ...state,
                ...{
                    approveRejectAttendanceCorrectionPending: false,
                    approveRejectAttendanceCorrectionRes: null,
                    approveRejectAttendanceCorrectionError: null,
                },
            };

        case 'HANDLE_CLEAR_UPDATE_LOG':
            return {
                ...state,
                ...{
                    updateAttendanceLogPending: false,
                    updateAttendanceLogRes: null,
                    updateAttendanceLogError: null,
                },
            };
        case 'HANDLE_CLEAR_APPLY_ATTENDANCE_CORRECTION':
            return {
                ...state,
                ...{
                    applyAttendanceCorrectionPending: false,
                    applyAttendanceCorrectionRes: null,
                    applyAttendanceCorrectionError: null,
                },
            };
        case 'HANDLE_CLEAR_ATTENDANCE_CORRECTION_LOGS_CORRECTION':
            return {
                ...state,
                ...{
                    attendanceCorrectionLogsPending: false,
                    attendanceCorrectionLogsRes: null,
                    attendanceCorrectionLogsError: null,
                },
            };

        case 'HANDLE_CLEAR_CORRECTION_FORM_DATA':
            return {
                ...state,
                ...{
                    correctionFormData: null,
                },
            };

        default:
            return state;
    }
};


export default createReducer(
    {
        [actions.applyAttendanceCorrectionRequest]: handleApplyAttendanceCorrectionRequest,
        [actions.applyAttendanceCorrectionSuccess]: handleApplyAttendanceCorrectionSuccess,
        [actions.applyAttendanceCorrectionError]: handleApplyAttendanceCorrectionError,

        [actions.getAttendanceCorrectionRequestDataRequest]: handleGetAttendanceCorrectionRequestDataRequest,
        [actions.getAttendanceCorrectionRequestDataSuccess]: handleGetAttendanceCorrectionRequestDataSuccess,
        [actions.getAttendanceCorrectionRequestDataError]: handleGetAttendanceCorrectionRequestDataError,

        [actions.approveRejectAttendanceCorrectionRequest]: handleApproveRejectAttendanceCorrectionRequest,
        [actions.approveRejectAttendanceCorrectionSuccess]: handleApproveRejectAttendanceCorrectionSuccess,
        [actions.approveRejectAttendanceCorrectionError]: handleApproveRejectAttendanceCorrectionError,

        [actions.getAttendanceCorrectionApprovalRequest]: handleGetAttendanceCorrectionApprovalRequest,
        [actions.getAttendanceCorrectionApprovalSuccess]: handleGetAttendanceCorrectionApprovalSuccess,
        [actions.getAttendanceCorrectionApprovalError]: handleGetAttendanceCorrectionApprovalError,

        [actions.updateAttendanceLogRequest]: handleUpdateAttendanceLogRequest,
        [actions.updateAttendanceLogSuccess]: handleUpdateAttendanceLogSuccess,
        [actions.updateAttendanceLogError]: handleUpdateAttendanceLogError,

        [actions.getAttendanceLogsRequest]: handleGetAttendanceLogsRequest,
        [actions.getAttendanceLogsSuccess]: handleGetAttendanceLogsSuccess,
        [actions.getAttendanceLogsError]: handleGetAttendanceLogsError,

        [actions.attendanceCorrectionLogsRequest]: handleAttendanceCorrectionLogsRequest,
        [actions.attendanceCorrectionLogsSuccess]: handleAttendanceCorrectionLogsSuccess,
        [actions.attendanceCorrectionLogsError]: handleAttendanceCorrectionLogsError,

        [actions.correctionFormData]: handleCorrectionFormData,

        [actions.handleClearCorrectionRequest]: handleClearCorrectionReducers,
    },
    initialState
)